window.docCollectorDatePicker = (function () {
    function open(input) {
        if (!input) {
            return;
        }

        try {
            if (typeof input.showPicker === "function") {
                input.showPicker();
                return;
            }
        } catch (e) {
        }

        input.focus();
        input.click();
    }

    return {
        open
    };
})();
